export default "__VITE_ASSET__BEgWuxEM__"